/**
 * @generated SignedSource<<fe9ee1ed0c234767ff6931eed9ef960c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CanceledPackageBanner_memberPackage$data = {
  readonly cancelledOn: string | null | undefined;
  readonly endsOn: string | null | undefined;
  readonly id: string;
  readonly " $fragmentType": "CanceledPackageBanner_memberPackage";
};
export type CanceledPackageBanner_memberPackage$key = {
  readonly " $data"?: CanceledPackageBanner_memberPackage$data;
  readonly " $fragmentSpreads": FragmentRefs<"CanceledPackageBanner_memberPackage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CanceledPackageBanner_memberPackage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cancelledOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endsOn",
      "storageKey": null
    }
  ],
  "type": "MemberPackage",
  "abstractKey": null
};

(node as any).hash = "a852828fa6d3b3df3b437227aef3f5be";

export default node;
